export const ENV = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",
}

export const isProduction = (): boolean => {
  return process.env.REACT_APP_ENV === ENV.PRODUCTION
}